import { Suspense } from 'react'
import { App as AntApp } from 'antd'
import { Router } from './routes'
import Loading from './components/Loading'

function App() {
  return (
    <AntApp>
      <Suspense fallback={<Loading fullScreen />}>
        <Router />
      </Suspense>
    </AntApp>
  )
}

export default App
